import React from 'react';

/**
 * Describe your component here
 */
export function ErrorComponent(props) {
  const { error, errorInfo, onReset } = props;

  return (
    <div>
      <div className="flex items-center flex-col p-1">
        <h1>We are sorry!{'\n'} Something went wrong</h1>
        <div className="mb-4" />
        <p>Info: {errorInfo.componentStack}</p>
        <p>{String(error)}</p>
        <div className="mb-2" />
        <button onClick={onReset}>Reset</button>
      </div>
    </div>
  );
}
